import React, { useEffect, useState } from "react";
import Button from "../../components/Button/index";
import { Link } from "react-router-dom";

const calculateTimeRemaining = (targetDate) => {
  const total = Date.parse(targetDate) - Date.now();
  const seconds = Math.floor((total / 1000) % 60);
  const minutes = Math.floor((total / 1000 / 60) % 60);
  const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
  const days = Math.floor(total / (1000 * 60 * 60 * 24));
  return { total, days, hours, minutes, seconds };
};

const AuctionSlider = ({ item }) => {
  const [timer, setTimer] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    const endDate = new Date(item.endDate);

    if (Date.now() >= endDate.getTime()) {
      setIsExpired(true);
      return;
    }

    const interval = setInterval(() => {
      const newTime = calculateTimeRemaining(endDate);
      if (newTime.total <= 0) {
        setIsExpired(true);
        clearInterval(interval);
      } else {
        setTimer(newTime);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [item.endDate]);

  return (
    <div className="auction-card">
      <div className="status-tag flex items-center gap-1">
        {isExpired ? (
          <>
            {/* Live Icon */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="11"
              height="11"
              viewBox="0 0 11 11"
              fill="none"
            >
              <path
                d="M10.6777 11H4.83395C4.65596 11 4.51169 10.8557 4.51169 10.6777V10.334C4.51169 9.97798 4.80022 9.68944 5.15622 9.68944V9.30414C5.15622 8.79397 5.5713 8.37889 6.08147 8.37889H9.43019C9.94036 8.37889 10.3555 8.79397 10.3555 9.30414V9.68944C10.7115 9.68944 11 9.97798 11 10.334V10.6777C11 10.8556 10.8556 11 10.6777 11ZM6.96662 7.09722C6.75242 7.38146 6.34826 7.43829 6.06402 7.22402C5.7797 7.00985 5.72296 6.60568 5.93713 6.32134L7.87657 3.74766C8.09084 3.46333 8.49491 3.40659 8.77917 3.62077C9.0635 3.83503 9.12032 4.23911 8.90606 4.52346L6.96662 7.09722ZM2.33397 3.60618C2.1197 3.89042 1.7156 3.94725 1.43128 3.73298C1.14704 3.51881 1.09022 3.11473 1.30448 2.83038L3.24394 0.256726C3.45812 -0.0275981 3.86228 -0.0844242 4.14654 0.12984C4.43078 0.344103 4.4876 0.748181 4.27334 1.03253L2.33397 3.60618ZM3.74764 5.4785C3.27131 5.11956 2.9137 4.67385 2.69005 4.20454L4.94675 1.20984C5.45952 1.29552 5.98648 1.51631 6.4629 1.87534C6.93925 2.23428 7.29686 2.67999 7.52051 3.14921L5.26379 6.14409C4.75105 6.05841 4.22408 5.83751 3.74764 5.4785ZM2.87746 5.56242C3.0275 5.71533 3.18554 5.86196 3.35976 5.99329C3.53406 6.12456 3.71861 6.23606 3.90686 6.33822L3.48665 6.89589L2.45716 6.12018L2.87746 5.56242ZM2.06926 6.63488L3.09875 7.41059L1.15929 9.98436C0.945028 10.2687 0.54095 10.3254 0.25669 10.1112C-0.0276345 9.89698 -0.0843752 9.4929 0.129803 9.20856L2.06926 6.63488Z"
                fill="white"
              />
            </svg>
            Live
          </>
        ) : (
          <>
            {/* Upcoming Icon */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="9"
              height="9"
              viewBox="0 0 9 9"
              fill="none"
            >
              <path
                d="M0.731707 3.29268H0V7.46341C0 8.30488 0.695122 9 1.53659 9H7.46341C8.30488 9 9 8.30488 9 7.46341V3.29268H8.26829H0.731707ZM5.67073 4.84756C5.79878 4.70122 6.05488 4.71951 6.18293 4.84756C6.58537 5.21341 6.96951 5.57927 7.37195 5.96342C7.51829 6.10976 7.5 6.34756 7.37195 6.47561C7.0061 6.87805 6.64024 7.2622 6.2561 7.66463C6.10976 7.81098 5.87195 7.79268 5.7439 7.66463C5.59756 7.53659 5.61585 7.28049 5.7439 7.15244C6.01829 6.84146 6.31098 6.54878 6.58537 6.23781C6.27439 5.94512 5.96341 5.65244 5.65244 5.37805C5.5061 5.21342 5.52439 4.97561 5.67073 4.84756ZM4.20732 4.84756C4.33537 4.70122 4.59146 4.71951 4.71951 4.84756C5.12195 5.21341 5.5061 5.57927 5.90854 5.96342C6.05488 6.10976 6.03658 6.34756 5.90854 6.47561C5.54268 6.87805 5.17683 7.2622 4.79268 7.66463C4.64634 7.81098 4.40854 7.79268 4.28049 7.66463C4.13415 7.53659 4.15244 7.28049 4.28049 7.15244C4.55488 6.84146 4.84756 6.54878 5.12195 6.23781C4.81098 5.94512 4.5 5.65244 4.18902 5.37805C4.04268 5.21342 4.06098 4.97561 4.20732 4.84756ZM8.26829 2.56098H9V1.53659C9 0.713415 8.34146 0.0365854 7.51829 0V0.841463C7.51829 1.04268 7.35366 1.20732 7.15244 1.20732C6.95122 1.20732 6.78658 1.02439 6.78658 0.841463V0H2.26829V0.804878C2.26829 1.0061 2.10366 1.17073 1.90244 1.17073C1.70122 1.17073 1.53659 0.987805 1.53659 0.804878V0C0.695122 0 0 0.695122 0 1.53659V2.56098H0.731707H8.26829Z"
                fill="white"
              />
            </svg>
            Upcoming
          </>
        )}
      </div>

      <Link to={`/auction/${item.id}`}>
        <img src={item?.image} alt="Auction Car" className="auction-image" />
      </Link>

      <div className="timer-box">
        {isExpired ? (
          <span className="live-text">Auction is Live!</span>
        ) : (
          <>
            <p>
              <span>{timer.days}</span> <span>Days</span>
            </p>
            <p>
              <span>{timer.hours}</span> <span>Hours</span>
            </p>
            <p>
              <span>{timer.minutes}</span> <span>Minutes</span>
            </p>
            <p>
              <span>{timer.seconds}</span> <span>Seconds</span>
            </p>
          </>
        )}
      </div>

      {isExpired && (
        <div className="lot-number">
          Lot # {item.id.toString().padStart(3, "0")}
        </div>
      )}

      <div className="acution-content-box">
        <h4 className="card-title">
          <Link to={`/auction/${item.id}`}>{item.title}</Link>
        </h4>
        <div className="align-content">
          <p className="starting-bid">
            <span>{isExpired ? "Current bid:" : "Starting bid:"}</span>{" "}
            {"$" + item.startingBid}
          </p>
          <Button
            className={isExpired ? "hover-red" : "hover-black"}
            text={isExpired ? "Bid Now" : "Notify Me"}
            bgColor={isExpired ? "black" : "red"}
            textColor="white"
            primary={true}
            onClick={() =>
              console.log(isExpired ? "Bid Now clicked" : "Notify Me clicked")
            }
          />
        </div>
      </div>
    </div>
  );
};

export default AuctionSlider;
